<!-- 新建/编辑管理员管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <!-- 上传图片 -->
        <div class="cropper-app">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="用户名" prop="name">
              <div class="list-img-box">
                <el-input placeholder="请输入用户名" v-model="formValidate.name"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="密码" prop="newPassword">
              <div class="list-img-box">
                <el-input placeholder="请输入密码" v-model="formValidate.newPassword"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="确认密码" prop="newPasswordNext">
              <div class="list-img-box">
                <el-input placeholder="请输入密码" v-model="formValidate.newPasswordNext"></el-input>
              </div>
            </el-form-item>
          </el-form>
        <!-- 保存 -->
        <div :style="{textAlign:'center'}">
          <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
          <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
        </div>
      </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  // 局部MD5引用
  import md5 from 'js-md5'
  export default {
    name: 'administratorsManagementOperation',
    data () {
      // 验证密码和确认密码
      let validatePassNext = (rule, value, callback) => {
        if (value !== this.formValidate.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        formValidate: {
          name: '',//添加地标名称
          newPassword: "",// 新密码
          newPasswordNext: "",// 确认密码
        },
        ruleValidate: { //学校非空验证
          name: [
            { required: true, message: '请输入地标名称', trigger: 'blur'}
          ],
          newPassword: [
            {required: true, message: '请输入新密码', trigger: 'blur'},
          ],
          newPasswordNext: [
            {required: true, message: '请输入确认密码', trigger: 'blur'},
            {validator: validatePassNext, trigger: 'blur'},
          ],
        }
      }
    },
    methods: {
      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate( (valid) => {
            if (valid) {
              let params = {},title="新增";
              if (this.$route.query.data == undefined){
                params = {
                  name:this.formValidate.name,
                  password:md5(this.formValidate.newPassword),
                  status:1
                }
              } else {
                params = {
                  id:this.$route.query.data.id,
                  name:this.formValidate.name,
                  password:md5(this.formValidate.newPassword),
                  status:1
                }
                title = "编辑";
              }
              this.$api.saveOrUpdateAdmin({parameter : JSON.stringify(params)}).then(res => {
                if (res.data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$router.push('/administratorsManagement');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/administratorsManagement');
      }
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.name = this.$route.query.data.name;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/administratorsManagementOperation.vue